import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useAdminAuth} from '../contexts/AdminAuthContext';
import {Spin, message} from 'antd';
import {PUBLIC_ADMIN_ROUTES, ROUTES} from '../constants/PathRoutes';
import Loading from "./admin/Loading";


export default function ProtectedAdminRoute({children}) {
    const {isAuthenticated, hasRoutePermission, loading} = useAdminAuth();
    const location = useLocation();

    if (loading) {
        return (
            <Loading minHeight={'100vh'}/>
        );
    }

    //VERIFICA SE ESTA AUTENTICADO E SE NÃO É UMA ROTA PUBLICA
    if (!isAuthenticated() && !Object.values(PUBLIC_ADMIN_ROUTES).includes(location.pathname)) {
        return <Navigate to={ROUTES.ADMIN}/>;
    }
    if (!hasRoutePermission(location.pathname)) {
        message.warning('Você não tem permissão para acessar esta página');
        return <Navigate to={ROUTES.ADMIN_DASHBOARD} replace/>;
    }

    return children;
}